module.exports = __webpack_public_path__ + "11da2d4ee933036a7a149850bf824b51.svg";